/**
 * @fileoverview Checkbox rows for sectors the company attends, four per row.
 */

import styles from "./Certifications.module.css";

const SectorCheckboxRows = ({
  availableSectors,
  sectors,
  onSectorCheckboxChange,
}) => {
  const rows = [];
  for (let i = 0; i < availableSectors.length; i += 4) {
    const rowItems = availableSectors.slice(i, i + 4);
    rows.push(
      <div key={`sector-row-${i}`} className={styles.checkboxRow}>
        {rowItems.map((sector) => (
          <div key={sector.value} className={styles.checkboxItem}>
            <input
              type="checkbox"
              id={sector.value}
              className={styles.checkbox}
              checked={sectors.some((s) => s.value === sector.value)}
              onChange={() => onSectorCheckboxChange(sector.value)}
            />
            <label htmlFor={sector.value} className={styles.checkboxLabel}>
              {sector.label}
            </label>
          </div>
        ))}
      </div>,
    );
  }
  return rows;
};

export default SectorCheckboxRows;
